const NoDataPage = ({ img, text, subText }) => {
    return (
        <>
            <div className="no_data_div">
                <div className="text-center">
                    {img && <img alt="" src={img} width='150px' />}
                    {text && <h5 className="my-3">{text}</h5>}
                    {subText && <h5>{subText}</h5>}
                </div>
            </div>
        </>
    )
}

export default NoDataPage;